import { FC } from 'react';

type WordmarkSize = 'nav' | 'hero' | 'footer';

type Props = {
    className?: string;
    size?: WordmarkSize;
};

const sizeClass: Record<WordmarkSize, string> = {
    nav: 'text-2xl',
    hero: 'text-6xl md:text-7xl lg:text-8xl',
    footer: 'text-3xl',
};

const Wordmark: FC<Props> = ({ className = '', size = 'nav' }) => {
    return (
        <span
            className={`font-display font-extrabold tracking-tighter text-fg ${sizeClass[size]} ${className}`}
            aria-label="n33no"
        >
            n<span className="text-accent">33</span>no
        </span>
    );
};

export { Wordmark };
